import { render, staticRenderFns } from "./activate-account.vue?vue&type=template&id=34861660&scoped=true&"
import script from "./activate-account.vue?vue&type=script&lang=ts&"
export * from "./activate-account.vue?vue&type=script&lang=ts&"
import style0 from "./activate-account.vue?vue&type=style&index=0&id=34861660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34861660",
  null
  
)

export default component.exports